import { DEFAULT_GC_TIME, DEFAULT_STALE_TIME } from '@/client/constants';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import useGetQueryFn from '../use-get-query-fn';
import { WhatsAppStatsResponse } from '@/client/types/whatsapp';

type QueryResponse = WhatsAppStatsResponse;

export const createWhatsappMetricsKey = (additional: any[] = []) => [
  'whatsapp-metrics',
  ...additional,
];

export const useGetWhatsappMetricsQuery = (additionalProps = {}) => {
  const queryFn = useGetQueryFn<QueryResponse>({
    defaultErrorMessage: 'An unexpected error occurred while fetching WhatsApp Metrics',
    endpoint: `/api/admin/whatsapp/stats`,
  });

  return useQuery({
    queryKey: createWhatsappMetricsKey([additionalProps]),
    queryFn: () => queryFn({ ...additionalProps }),
    staleTime: DEFAULT_STALE_TIME,
    gcTime: DEFAULT_GC_TIME,
    placeholderData: keepPreviousData,
  });
};